import React, { useState } from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { TicketIcon, PlusIcon, SaveIcon, XIcon, CheckIcon, UserIcon, ClockIcon } from 'lucide-react';
export function OccasionalPasses({
  locale,
  onAddPasses,
  showPassForm,
  setShowPassForm
}) {
  // Mock data for pass balance
  const [passBalance, setPassBalance] = useState({
    currentCount: 42,
    pricePerPass: 25,
    currency: 'USD',
    expiryHours: 12
  });
  // Mock data for pass purchases
  const [purchases, setPurchases] = useState([{
    id: 'purchase-1',
    date: '2023-09-01T10:00:00Z',
    count: 50,
    pricePerPass: 25,
    totalPrice: 1250,
    currency: 'USD',
    purchasedBy: 'John Smith'
  }, {
    id: 'purchase-2',
    date: '2023-10-15T14:30:00Z',
    count: 10,
    pricePerPass: 25,
    totalPrice: 250,
    currency: 'USD',
    purchasedBy: 'Jane Doe'
  }]);
  // Mock data for pass usage
  const [passUsage, setPassUsage] = useState([{
    id: 'pass-1',
    userId: 'user-001',
    userName: 'Michael Johnson',
    startTime: '2023-10-20T09:15:00Z',
    expiryTime: '2023-10-20T21:15:00Z',
    active: false
  }, {
    id: 'pass-2',
    userId: 'user-002',
    userName: 'Sarah Williams',
    startTime: '2023-10-21T10:30:00Z',
    expiryTime: '2023-10-21T22:30:00Z',
    active: false
  }, {
    id: 'pass-3',
    userId: 'user-003',
    userName: 'Robert Brown',
    startTime: '2023-10-22T08:45:00Z',
    expiryTime: '2023-10-22T20:45:00Z',
    active: true
  }]);
  // Form state for purchasing passes
  const [formData, setFormData] = useState({
    count: 10,
    pricePerPass: passBalance.pricePerPass
  });
  // Calculate total price
  const totalPrice = formData.count * formData.pricePerPass;
  // Handle form field changes
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    if (name === 'count') {
      setFormData({
        ...formData,
        count: parseInt(value, 10) || 0
      });
    }
  };
  // Handle price change
  const handlePriceChange = e => {
    const {
      value
    } = e.target;
    // Remove non-numeric characters except decimal point
    const sanitizedValue = value.replace(/[^\d.]/g, '');
    const priceValue = parseFloat(sanitizedValue || '0');
    if (!isNaN(priceValue)) {
      setFormData({
        ...formData,
        pricePerPass: priceValue
      });
    }
  };
  // Handle form submission
  const handleSubmit = e => {
    e.preventDefault();
    // Create new purchase
    const newPurchase = {
      id: `purchase-${new Date().getTime()}`,
      date: new Date().toISOString(),
      count: formData.count,
      pricePerPass: formData.pricePerPass,
      totalPrice: totalPrice,
      currency: passBalance.currency,
      purchasedBy: 'Admin'
    };
    // Update purchases and pass balance
    setPurchases([newPurchase, ...purchases]);
    setPassBalance({
      ...passBalance,
      currentCount: passBalance.currentCount + formData.count
    });
    // Reset form
    setShowPassForm(false);
  };
  return <div className="space-y-8" data-id="element-16526">
      {showPassForm ? <div className="bg-white shadow sm:rounded-lg" data-id="element-16527">
          <div className="px-4 py-5 sm:p-6" data-id="element-16528">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-16529">
              Purchase Occasional Passes
            </h3>
            <form className="mt-5 space-y-6" onSubmit={handleSubmit} data-id="element-16530">
              <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-16531">
                <div className="sm:col-span-3" data-id="element-16532">
                  <label htmlFor="count" className="block text-sm font-medium text-gray-700" data-id="element-16533">
                    Number of Passes
                  </label>
                  <div className="mt-1" data-id="element-16534">
                    <input type="number" name="count" id="count" value={formData.count} onChange={handleChange} min="1" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-16535" />
                  </div>
                </div>
                <div className="sm:col-span-3" data-id="element-16536">
                  <label htmlFor="pricePerPass" className="block text-sm font-medium text-gray-700" data-id="element-16537">
                    Price Per Pass
                  </label>
                  <div className="mt-1" data-id="element-16538">
                    <div className="flex rounded-md shadow-sm" data-id="element-16539">
                      <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm" data-id="element-16540">
                        {passBalance.currency}
                      </span>
                      <input type="text" name="pricePerPass" id="pricePerPass" value={formData.pricePerPass} onChange={handlePriceChange} pattern="^\d*(\.\d{0,2})?$" placeholder="0.00" className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300" required data-id="element-16541" />
                    </div>
                  </div>
                </div>
                <div className="sm:col-span-6" data-id="element-16542">
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-16543">
                    <div className="flex justify-between" data-id="element-16544">
                      <span className="text-sm font-medium text-gray-500" data-id="element-16545">
                        Total Price:
                      </span>
                      <span className="text-lg font-bold text-gray-900" data-id="element-16546">
                        {formatCurrency(totalPrice, passBalance.currency, locale)}
                      </span>
                    </div>
                    <div className="mt-2 text-xs text-gray-500" data-id="element-16547">
                      Passes expire {passBalance.expiryHours} hours after
                      activation
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end space-x-3" data-id="element-16548">
                <button type="button" onClick={() => setShowPassForm(false)} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-16549">
                  Cancel
                </button>
                <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-16550">
                  <SaveIcon className="h-4 w-4 mr-2" data-id="element-16551" />
                  Purchase Passes
                </button>
              </div>
            </form>
          </div>
        </div> : <>
          {/* Pass Balance Card */}
          <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200" data-id="element-16552">
            <div className="px-4 py-5 sm:px-6" data-id="element-16553">
              <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-16554">
                Occasional Pass Balance
              </h3>
              <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-16555">
                Current balance and pass information
              </p>
            </div>
            <div className="px-4 py-5 sm:p-6" data-id="element-16556">
              <div className="sm:flex sm:items-center sm:justify-between" data-id="element-16557">
                <div className="flex items-center" data-id="element-16558">
                  <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-16559">
                    <TicketIcon className="h-6 w-6 text-green-600" data-id="element-16560" />
                  </div>
                  <div className="ml-5" data-id="element-16561">
                    <h4 className="text-lg font-bold text-gray-900" data-id="element-16562">
                      {passBalance.currentCount} passes
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-16563">
                      {formatCurrency(passBalance.pricePerPass, passBalance.currency, locale)}{' '}
                      per pass
                    </p>
                  </div>
                </div>
                <div className="mt-5 sm:mt-0" data-id="element-16564">
                  <button type="button" onClick={onAddPasses} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-16565">
                    <PlusIcon className="h-4 w-4 mr-2" data-id="element-16566" />
                    Purchase Passes
                  </button>
                </div>
              </div>
              <div className="mt-5 border-t border-gray-200 pt-5" data-id="element-16567">
                <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2" data-id="element-16568">
                  <div className="sm:col-span-1" data-id="element-16569">
                    <dt className="text-sm font-medium text-gray-500" data-id="element-16570">
                      Pass Validity
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900" data-id="element-16571">
                      {passBalance.expiryHours} hours
                    </dd>
                  </div>
                  <div className="sm:col-span-1" data-id="element-16572">
                    <dt className="text-sm font-medium text-gray-500" data-id="element-16573">
                      Used This Month
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900" data-id="element-16574">
                      {passUsage.length} passes
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-16575">
            {/* Purchases Section */}
            <div className="bg-white shadow sm:rounded-lg" data-id="element-16576">
              <div className="px-4 py-5 sm:px-6" data-id="element-16577">
                <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-16578">
                  Pass Purchases
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-16579">
                  History of pass purchases
                </p>
              </div>
              <div className="border-t border-gray-200" data-id="element-16580">
                <div className="overflow-hidden overflow-x-auto" data-id="element-16581">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-16582">
                    <thead className="bg-gray-50" data-id="element-16583">
                      <tr data-id="element-16584">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16585">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16586">
                          Passes
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16587">
                          Total
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16588">
                          Purchased By
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-16589">
                      {purchases.map(purchase => <tr key={purchase.id} data-id="element-16590">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-16591">
                            {new Date(purchase.date).toLocaleDateString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-16592">
                            {purchase.count}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-16593">
                            {formatCurrency(purchase.totalPrice, purchase.currency, locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-16594">
                            {purchase.purchasedBy}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  {purchases.length === 0 && <div className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-16595">
                      No purchase history found.
                    </div>}
                </div>
              </div>
            </div>
            {/* Usage Section */}
            <div className="bg-white shadow sm:rounded-lg" data-id="element-16596">
              <div className="px-4 py-5 sm:px-6" data-id="element-16597">
                <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-16598">
                  Pass Usage
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-16599">
                  Recent pass usage by users
                </p>
              </div>
              <div className="border-t border-gray-200" data-id="element-16600">
                <div className="overflow-hidden overflow-x-auto" data-id="element-16601">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-16602">
                    <thead className="bg-gray-50" data-id="element-16603">
                      <tr data-id="element-16604">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16605">
                          User
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16606">
                          Start Time
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16607">
                          Expiry
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-16608">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-16609">
                      {passUsage.map(pass => <tr key={pass.id} data-id="element-16610">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-16611">
                            <div className="flex items-center" data-id="element-16612">
                              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-16613">
                                <UserIcon className="h-5 w-5 text-gray-500" data-id="element-16614" />
                              </div>
                              <div className="ml-4" data-id="element-16615">
                                <div className="text-sm font-medium text-gray-900" data-id="element-16616">
                                  {pass.userName}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-16617">
                            {new Date(pass.startTime).toLocaleString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-16618">
                            {new Date(pass.expiryTime).toLocaleString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-16619">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${pass.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-16620">
                              {pass.active ? <>
                                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-16621" />
                                  Active
                                </> : <>
                                  <CheckIcon className="h-3 w-3 mr-1" data-id="element-16622" />
                                  Completed
                                </>}
                            </span>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  {passUsage.length === 0 && <div className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-16623">
                      No pass usage found.
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
}